module.exports = __webpack_public_path__ + "img/cydrasil-logo-with-text.84211f26.png";